export default __webpack_public_path__ + "static/media/logo-d.5613f85a.png";